/* eslint-disable sonarjs/no-duplicate-string */
// 9fbef606107a605d69c0edbcd8029e5d
export const GLOBAL_CART_ITEM_TILE_LABELS = 'global.cartItemTile';

export const lblCartTileProductBrandAlt = 'lbl_cartTile_productBrandAlt';
export const lblCartTileProductImageAlt = 'lbl_cartTile_productImageAlt';
export const lblCartTileBopis = 'lbl_cartTile_bopis';
export const lblCartTileBoss = 'lbl_cartTile_boss';
export const lblCartTileNoRushPickup = 'lbl_cartTile_noRushPickup';
export const lblCartTilePickUpToday = 'lbl_cartTile_pickUpToday';
export const lblCartTileShipToHome = 'lbl_cartTile_shipToHome';
export const lblCartTileExtra = 'lbl_cartTile_extra';
export const lblCartTileDelete = 'lbl_cartTile_delete';
export const lblCartTileTomorrow = 'lbl_cartTile_tomorrow';
export const lblCartTilePhone = 'lbl_cartTile_phone';
export const lblCartTileAt = 'lbl_cartTile_at';
export const lblCartTileToday = 'lbl_cartTile_today';
export const lblCartTileBy = 'lbl_cartTile_by';
export const lblCartTileBossUnavailable = 'lbl_cartTile_bossUnavailable';
export const lblCartTileBossReqQtyUnavailable = 'lbl_cartTile_bossReqQtyUnavailable';
export const lblCartTileBopisUnavailable = 'lbl_cartTile_bopisUnavailable';
export const lblCartTileEcomUnavailable = 'lbl_cartTile_ecomUnavailable';
export const lblCartTileNotAvailableOnlineOnly = 'lbl_cartTile_notAvailableOnlineOnly';
export const lblCartTileNotAvailableClearanceItem = 'lbl_cartTile_notAvailableClearanceItem';
export const lblCartTileSoldOut = 'lbl_cartTile_soldOut';
export const lblCartTileBossInEligible = 'lbl_cartTile_bossInEligible';
export const lblCartTileChangeStore = 'lbl_cartTile_changeStore';
export const lblCartTileBopisPickUp = 'lbl_cartTile_bopis_pickUp';
export const lblNotAvailable = 'lbl_not_available';
export const lblEddPlaceholdeerBoss = 'lbl_edd_placeholdeer_boss';
export const lblOfferApplied = 'lbl_offer_applied';
export const lblOtherPromotion = 'lbl_other_promotion';
export const lblAccessoryHeading = 'lbl_accessory_heading';
export const lblAccessoryRule = 'lbl_accessory_rule';
export const lblViewAll = 'lbl_view_all';
export const lblModalDescription = 'lbl_modal_description';
export const lblModalButton = 'lbl_modal_button';
export const lblMultiplePromotionsApplied = 'lbl_multiple_promotions_applied';
export const lblModalOfferValidDate = 'lbl_modalOffer_validDate';
export const lblModalOfferEligibleItems = 'lbl_modalOffer_eligibleItems';
export const BuyXSaveYPromo1LblModalOfferTncDescription =
  'BuyXSaveYPromo1_lbl_modalOffer_tnc_description';
export const lblModalOfferBtmCTA = 'lbl_modalOffer_btm_CTA';
export const BuyXSaveYPromo1LblModalOfferDetailDesc = 'BuyXSaveYPromo1_lbl_modalOffer_detail_desc';
export const lblModalOfferTncDescription = 'lbl_modalOffer_tnc_description';
export const lblModalOfferDetailHeadingText = 'lbl_modalOffer_detail_heading_text';
export const lblAccessoryNonMandatoryHeading = 'lbl_accessory_non_mandatory_heading';
export const lblAccessoryBackpackHeading = 'lbl_accessory_backpack_heading';
export const lblSelectedAccessoryText = 'lbl_selected_accessory_text';
export const lblSoldOut = 'lbl_sold_out';
export const lblSelectOnlyOne = 'lbl_select_only_one';
export const lblSecondaryAccessoryTitle = 'lbl_secondary_accessory_title';
export const lblAddAccessory = 'lbl_add_accessory';
export const listPriceSuffix = 'list_price_suffix';
export const lblAccessoryRuleSecondary = 'lbl_accessory_rule_secondary';
export const lblMinimumAccessoryError = 'lbl_minimum_accessory_error';
export const lblMinimumAccessoryErrorSecondary = 'lbl_minimum_accessory_error_secondary';
export const lblAccessoryRuleMandatory = 'lbl_accessory_rule_mandatory';
export const lblAccessoryRuleMandatoryMultiselect = 'lbl_accessory_rule_mandatory_multiselect';
export const lblAccessoryPriceIncluded = 'lbl_accessory_price_included';
export const lblMinimumAccessoryErrorSingle = 'lbl_minimum_accessory_error_single';
export const lblAccessoryRuleSecondaryMultiselect = 'lbl_accessory_rule_secondary_multiselect';
export const lblSelectedAccessory = 'lbl_selected_accessory';
export const lblTotalSavings = 'lbl_total_savings';
export const lblItemPromotion = 'lbl_item_promotion';
export const lblGetItToday = 'lbl_get_it_today';
export const lblBestOffers = 'lbl_best_offers';
export const lblBestOffer = 'lbl_best_offer';
export const lblModalOfferHeading = 'lbl_modalOffer_heading';
export const lblCartTileFit = 'lbl_cartTile_fit';
export const lblCartTileOff = 'lbl_cartTile_off';

export default {
  global: {
    cartItemTile: {
      referred: [],
      [lblCartTileOff]: 'OFF',
      [lblCartTileFit]: 'Points',
      [lblCartTileProductBrandAlt]: 'Brand',
      [lblCartTileProductImageAlt]: 'Product',
      [lblCartTileBopis]: 'I’ll pick up in store at #store# Today',
      [lblCartTileBoss]:
        'I’ll pick up in store at #store# by #startMonth# #startdate# - #endMonth# #enddate#',
      [lblCartTileNoRushPickup]: 'NO RUSH Pick Up',
      [lblCartTilePickUpToday]: 'Pick Up Today',
      [lblCartTileShipToHome]: 'Ship to Home',
      [lblCartTileExtra]: 'EXTRA',
      [lblCartTileDelete]: 'Delete',
      [lblCartTileTomorrow]: 'Tomorrow',
      [lblCartTilePhone]: 'Phone',
      [lblCartTileAt]: 'At',
      [lblCartTileToday]: 'Today',
      [lblCartTileBy]: 'by',
      [lblCartTileBossUnavailable]: 'Choose a different color, fit, size or store',
      [lblCartTileBossReqQtyUnavailable]: 'Choose a different color, fit, size, qty or store',
      [lblCartTileBopisUnavailable]: 'Choose a different color, fit, size or store',
      [lblCartTileEcomUnavailable]: 'Choose a different color, fit, size or store',
      [lblCartTileNotAvailableOnlineOnly]: 'Not available (Online Only)',
      [lblCartTileNotAvailableClearanceItem]: 'Not available (Clearance Item)',
      [lblCartTileSoldOut]: 'This item is sold out',
      [lblCartTileBossInEligible]: 'This item is unavailable for ship to store',
      [lblCartTileChangeStore]: 'Change Store',
      [lblCartTileBopisPickUp]: 'Pick Up',
      [lblNotAvailable]: 'Not available',
      [lblEddPlaceholdeerBoss]: '5 to 15 days',
      [lblOfferApplied]: 'offer(s) applied!',
      [lblOtherPromotion]: 'Order Discount',
      [lblAccessoryHeading]: 'Personalize it!',
      [lblAccessoryRule]:
        'You must select at least one accessory. In case of multiple selections of accessories, additional charges will be applied.',
      [lblViewAll]: 'View all',
      [lblModalDescription]:
        'You must select at least one accessory for your backpack. In case of multiple selections of accessories, additional charges will be applied.',
      [lblModalButton]: 'SELECT ADD ON',
      [lblMultiplePromotionsApplied]: 'offers applied',
      [lblModalOfferValidDate]: 'Valid through ',
      [lblModalOfferEligibleItems]: 'ELIGIBLE ITEMS',
      [BuyXSaveYPromo1LblModalOfferTncDescription]:
        ' Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor             incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud             exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      [lblModalOfferBtmCTA]: 'View All Products',
      [BuyXSaveYPromo1LblModalOfferDetailDesc]:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit amet.',
      [lblModalOfferTncDescription]:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore. Aliqua ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ',
      [lblModalOfferDetailHeadingText]: 'Offer Details',
      [lblAccessoryNonMandatoryHeading]: 'Personalize it with an accessory!',
      [lblAccessoryBackpackHeading]: 'Backpack Accessories',
      [lblSelectedAccessoryText]: 'Selected',
      [lblSoldOut]: 'Sold Out',
      [lblSelectOnlyOne]: 'Selecting a second option will deselect your initial selection',
      [lblSecondaryAccessoryTitle]: 'Personalize it!',
      [lblAddAccessory]: 'ADD ACCESSORY',
      [listPriceSuffix]: 'each',
      [lblAccessoryRuleSecondary]: 'Select 1 personalized accessory in order to add to bag.',
      [lblMinimumAccessoryError]: 'Select at least 1 style before adding to bag',
      [lblMinimumAccessoryErrorSecondary]: 'Select at least 1 style before continuing',
      [lblAccessoryRuleMandatory]:
        'Select 1 personalized accessory in order to add to bag. Note: selecting a second option will deselect your initial selection.',
      [lblAccessoryRuleMandatoryMultiselect]:
        'Select at least 1 personalized accessory in order to add to bag. Note: additional charges apply on extra accessories selected.',
      [lblAccessoryPriceIncluded]: 'Included',
      [lblMinimumAccessoryErrorSingle]: 'Select 1 style before adding to bag.',
      [lblAccessoryRuleSecondaryMultiselect]:
        'Select 1 personalized accessory in order to add to bag. Note: additional charges apply on extra accessories selected.',
      [lblSelectedAccessory]: 'Selected accessories',
      [lblTotalSavings]: 'Total Savings',
      [lblItemPromotion]: 'Limited-Time Savings',
      [lblGetItToday]: 'Get it today!',
      [lblBestOffers]: 'Limited-Time Savings',
      [lblBestOffer]: 'Limited-Time Savings',
      [lblModalOfferHeading]: 'Limited-Time Savings',
    },
  },
};
